import { Component } from '@angular/core';
import { TimelineMax, Power2, Quad } from 'gsap';
import * as CustomWiggle from '../../../assets/gsap/plugins/CustomWiggle';
import * as CustomBounce from '../../../assets/gsap/plugins/CustomBounce';
import { CbsBasicsComponent } from '../animation-base-classes/cbs-basics.component';
import { IconService } from '../../core/icon.service';
import { params as paramsStill } from './still.params';
import { params as paramsSocial } from './social.params';
import { params as paramsVideo } from './video.params';
import * as _ from 'lodash';
import * as d3 from 'd3';

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss']
})
export class TemplateComponent extends CbsBasicsComponent {

  private backgroundGroup;
  private textGroup;
  private circleGroup;

  constructor(
    public iconService: IconService,
  ) {
    super(iconService);
    this.paramObject = {
      'plaatje': paramsStill,
      'social': paramsSocial,
      'video': paramsVideo
    };
  }

  public async calculateValues() {
    super.calculateValues();
  }

  public async createElements() {
    this.backgroundGroup = this.host.select('#background');
    this.backgroundGroup.selectAll('*').remove();
    this.drawBackground(this.backgroundGroup, this.values);
    this.textGroup = this.host.select('#title');
    this.textGroup.selectAll('*').remove();
    this.drawText(this.textGroup, this.values);

    this.circleGroup = this.host.select('#circle');
    this.circleGroup.selectAll('*').remove();
    this.drawCircle(this.circleGroup, this.values);
  }

  public async createAnimation(noAnimation: boolean = false) {
    let p = k => this.parameters[k];
    let v = k => this.values[k];

    let main = new TimelineMax({ repeat: -1 });
    if (!noAnimation) {
      let templateAnimation = new TimelineMax();
      let idString = `template-${this.id}`;
      switch (this.values['animationType']['key']) {
        case 'bounce':
          this.bounce(templateAnimation, this.values, idString, 50);
          break;
        case 'zoom':
          this.zoom(templateAnimation, this.values, idString, 1.1);
          break;
        case 'slideIn': {
          let xValue;
          xValue = this.values['width'];
          templateAnimation.from(`#${idString}`, 1, { attr: { 'cx': xValue } }, 'startIconAnimation');
          break;
        }
        case 'slideOut': {
          let xValue;
          xValue = 1.5 * this.values['width'];
          templateAnimation.to(`#${idString}`, 1, { attr: { 'cx': xValue } }, 'startIconAnimation');
          break;
        }
        default:
      }
      templateAnimation.duration(this.timings['templateAnimation']);
      main.add(templateAnimation);

      let pauseAnimation = new TimelineMax()
        .set({}, {}, 'positionForStill')
        .set({}, {}, 1)
        .duration(this.timings['pauseEnd']);
      main.add(pauseAnimation);
    }

    this.animation = main;
    return this.animation;
  }

  public drawBackground(selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', values['colorScheme']['value'][0])
      .attr('stroke', 'none');
  }

  public drawCircle(selection, values) {
    selection.append('circle')
      .attr('id', `template-${this.id}`)
      .attr("cx", values['offsetX'])
      .attr("cy", values['offsetY'])
      .attr("r",  values['circleSize'])
      .style("fill",  values['circleColorScheme']['value'][0]);
  }

  public drawText(selection, values) {
  //
  }

  public bounce(timeline, values, id, yValue) {
    CustomBounce.create('bounceIcon', { strength: 0.7, squash: 2, squashID: 'bounceIcon-squash', endAtStart: true });
    timeline.to(`#${id}`, 1, { attr: { 'cy': -yValue}, ease: 'bounceIcon' }, 'startIconAnimation');
  }

  public zoom(timeline, values, id, zoomValue) {
    timeline.to(`#${id}`, 0.25, { scale: zoomValue, transformOrigin: '50% 100%', ease: Quad.easeInOut }, 'startIconAnimation');
    timeline.to(`#${id}`, 0.25, { scale: 1.0, transformOrigin: '50% 100%', ease: Quad.easeInOut }, 'stepIconAnimation1');
    timeline.to(`#${id}`, 0.25, { scale: zoomValue, transformOrigin: '50% 100%', ease: Quad.easeInOut }, 'stepIconAnimation2');
    timeline.to(`#${id}`, 0.25, { scale: 1.0, transformOrigin: '50% 100%', ease: Quad.easeInOut }, 'stepIconAnimation3');
  }

  public slideIn(timeline, values, id, xValue) {
    timeline.from(`#${id}`, 1, { attr: { 'cx': xValue } }, 'startIconAnimation');
  }

  public slideOut(timeline, values, id, xValue) {
    timeline.to(`#${id}`, 1, { attr: { 'cx': xValue, ease: Power2.easeIn } }, 'startIconAnimation');
  }
}



// WEBPACK FOOTER //
// ./src/app/animations/template/template.component.ts